exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actionButton--1A0so {\n  border: none;\n  border-radius: initial;\n  padding: 15px 0;\n}\n\n.videoIcon--15uGV {\n  position: absolute;\n  right: 1.25rem;\n  top: 1.25rem;\n  width: 60px;\n}\n\n", ""]);

// exports
exports.locals = {
	"actionButton": "actionButton--1A0so",
	"videoIcon": "videoIcon--15uGV"
};